import angular from 'angular';

/* @ngInject */
export default class SearchService {
    constructor($http, HPConfig, $location) {
        this.$http = $http;
        this.HPConfig = HPConfig;
        this.$location = $location;


        this.filters = [
            {
                filterId: 1,
                filterName: 'All Projects',
                selected: false,
            },
            {
                filterId: 2,
                filterName: 'Active Projects',
                selected: true,
            },
            {
                filterId: 3,
                filterName: 'Hidden Projects',
                selected: false,
            },
        ];
    }
    search(options) {
        const defaultSearchDataOptions = {
            SearchCriteria: 1,
            SearchValue: '',
            PageSize: '20',
            PageNumber: '0',
            LocationContractorId: null,
            DisplayOption: '2',
        };

        const promise = this.$http({
            // url: HPConfig.heroProApi + "/Loan/FundingRequest/Pipeline/Search",
            url: `${this.HPConfig.heroProApi}Loan/FundingRequest/Pipeline/SearchAll`,
            method: 'GET',
            params: angular.extend({}, defaultSearchDataOptions, options || {}),
        });

        this.heroProbe(promise);

        return promise;
    }
    getSearchFilters() {
        return this.filters;
    }

    // heroProbe
    heroProbe(promise) {
        if (this.$location.search().heroprobe !== undefined) {
            promise.then((response) => {
                console.table(response.data.PipelineFundingRequests, ['Owner1FirstName', 'Owner1LastName', 'FundingRequestId', 'LoanStateId', 'FundingRequestStateId', 'FinDocsStateId', 'PipelineStageId', 'FundingRequestPipelineStageId']);
            });
        }
    }
    // heroProbe
}



// WEBPACK FOOTER //
// ./src/app/search/search.service.js